import React from "react";

const Java_Exports = () => {
  return (
    <div>
      <h1>Java Exports</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Exports in Java.</p>
    </div>
  );
};

export default Java_Exports;
